import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import { ApiError, DataFetchResponse } from '../../../interfaces/apiResponse.type';
import { handleApiError } from '../../requestHelpers/requestHelpers';

export const useDeleteSessionToken = () => {
  const { t } = useTranslation();

  return useMutation<DataFetchResponse, ApiError<null>, string | number>(
    (id) => dataFetch.delete(`${DIGGER_API_SUFFIX}auth/tokens/session/${id}`),
    {
      onSuccess: () => {
        closableEnqueueSnackbar(t('tokenDeletedSuccessfully'), 'success');
      },
      onError: (error) => {
        handleApiError(error, t);
      },
    },
  );
};

export const useDeleteDeveloperToken = () => {
  const { t } = useTranslation();

  return useMutation<DataFetchResponse, ApiError<null>, string | number>(
    (id) => dataFetch.delete(`${DIGGER_API_SUFFIX}auth/tokens/developer/${id}`),
    {
      onSuccess: () => {
        closableEnqueueSnackbar(t('tokenDeletedSuccessfully'), 'success');
      },
      onError: (error) => {
        handleApiError(error, t);
      },
    },
  );
};
